module.exports = __webpack_public_path__ + "img/28.b2ec4fde.png";